"use client";

import PropTypes from "prop-types";
import { ConnectSectionRoot } from "./ConnectSection.styles";
import { ParallaxLayer } from "@react-spring/parallax";
import { BGIcon, Title } from "@components";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { Box, Typography } from "@mui/material";
import Carousel from "@components/elements/Carousel";
import ConnectCard from "@components/elements/ConnectCard";
import { useInView } from "react-intersection-observer";

const ConnectSection = ({ offset, speed, connectCards = [] }) => {
  const [ref, inView] = useInView({
    threshold: 0.6,
  });

  return (
    <>
      <ParallaxLayer offset={offset}>
        <BGIcon Icon={GroupAddIcon} />
      </ParallaxLayer>
      <ParallaxLayer offset={offset} speed={speed}>
        <ConnectSectionRoot ref={ref}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <Title>Connect</Title>
            <Typography
              sx={(theme) => ({
                marginTop: 1,
                textShadow: "5px 5px 5px black",
                textAlign: "center",
                fontSize: { xs: 12, md: 16 },
                color: theme.palette.common.white,
              })}
            >
              Connect with me professionally on these sites!
            </Typography>
          </Box>
          <Carousel>
            {connectCards.map((card, index) => (
              <ConnectCard
                key={card.title}
                {...card}
                inView={inView}
                enterDelay={index + 1}
              />
            ))}
          </Carousel>
        </ConnectSectionRoot>
      </ParallaxLayer>
    </>
  );
};

ConnectSection.propTypes = {
  offset: PropTypes.number,
  speed: PropTypes.number,
  connectCards: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
};

export default ConnectSection;
